import React, { useState, useEffect } from 'react';
import { Modal, Button, Divider, Form, Input, Row, Empty, message, Spin } from 'antd';
import { getProduct } from '../../services/productService';
import './product-sku-modal.scss';

function ProductSkuModal(props) {
    const { visible, merchant, onCancel, handleSelect, productId } = props || {};
    const [form] = Form.useForm();
    const [chosenSku, setChosenSku]: any = useState(null);
    const [product, setProduct]: any = useState();
    const [chosenParam, setChosenParam]: any = useState({});
    const [availableOption, setAvailableOption]: any = useState({});
    const [chosenFinished, setChosenFinished]: any = useState(false);
    const [skuId, setSkuId]: any = useState('');
    const [loading, setLoading] = useState(false);
    const pickerProps = {
        handlePickerClick,
        product,
        availableOption,
        chosenParam
    }

    useEffect(() => {
        if(productId) {
            getProductInfo(productId);
            form.setFieldsValue({id: productId});
        }
    }, [productId]);

    useEffect(() => {
        setChosenFinished(isChosenFinished(product, chosenParam));
    }, [product, chosenParam])

    useEffect(() => {
        if(product && skuId) {
            setSku(skuId);
            setSkuId('');
        }
    }, [product, skuId])

    function handleAdd() {
        handleSelect({
            sku: chosenSku || product?.availableSkus?.[0],
            product: product
        });
        onClose();
    }

    function handlePickerClick(type: string, item: any) {
        const cSku = choseSku({ [type]: item }, product, chosenParam);
        setChosenParam(cSku.chosenParam);
        setAvailableOption(cSku.availableOption);
        setChosenSku(cSku.chosenSku);
    }

    function handleSearch() {
        const id = form.getFieldValue('id');
        const orderItemId = form.getFieldValue('skuId');
        if(!id && !orderItemId) {
            message.error('请输入商品id');
            return null;
        }
        clearSku();
        if(orderItemId) {
            const productId = orderItemId.split('-')?.[1];
            const skuId = orderItemId.split('-')?.[2];
            if(productId) {
                setSkuId(skuId);
                getProductInfo(productId)
            }
        } else if(id) {
            getProductInfo(id)
        }
    }

    function getProductInfo(id) {
        if(loading) return null;
        setLoading(true);
        getProduct(id)
        .then(res => {
            setLoading(false);
            const m = res?.data?.merchantId;
            if(merchant && (merchant !== m)) {
                message.error('该商品不是限定商家的商品，请重新输入');
            } else {
                setProduct(res?.data || {});
            }
        })
        .catch(err => {
            setLoading(false);
        })
    }

    function setSku(skuId) {
        if(product) {
            const availableSkus = product.availableSkus;
            const currentSku = availableSkus?.find(item => item?.id === skuId);
            if(currentSku) {
                const cSku = choseSku({
                    color: currentSku?.color?.name,
                    size: currentSku?.size?.name,
                    width: currentSku?.attributes?.attributes?.width?.choices?.[0]
                }, product, chosenParam)
                setChosenParam(cSku.chosenParam);
                setAvailableOption(cSku.availableOption);
                setChosenSku(cSku.chosenSku);
            } else {
                message.error('没有可用的sku，请自行选择');
            }
        }
    }

    function clearSku() {
        setProduct(null);
        setChosenSku(null);
        setChosenParam({});
        setAvailableOption({});
        setChosenFinished(false);
        setSkuId('')
    }

    function clearAll() {
        clearSku();
        form.resetFields();
    }

    function onClose() {
        clearAll();
        onCancel();
    }

    return <Modal
        title="添加商品"
        visible={visible}
        footer={null}
        width={'60%'}
        className='m-product-sku-modal'
        onCancel={onClose}
    >
        <Form name='product-select' form={form}>
            <Row>
                <Form.Item label="ProductId" name="id">
                    <Input style={{ width: 200 }} allowClear />
                </Form.Item>
                <Form.Item label="SkuId" name="skuId" style={{margin: '0 25px'}}>
                    <Input style={{ width: 200 }} allowClear />
                </Form.Item>
                <Button onClick={handleSearch}>查询</Button>
            </Row>
        </Form>
        <Divider />
        <Spin spinning={loading}>
            {product ? <React.Fragment>
                <div className='product-info'>
                    <CartProductInfo chosenSku={chosenSku} product={product} />
                    <CartColorPicker {...pickerProps} />
                    <CartWidthPicker {...pickerProps} />
                    <CartSizePicker {...pickerProps} />
                </div>
                <Row justify='center'><Button disabled={!chosenFinished} onClick={handleAdd} type="primary">添加商品</Button></Row>
            </React.Fragment> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
        </Spin>
    </Modal>
}

function CartProductInfo(props: any) {
    const { chosenSku, product } = props;
    const price = getPrice(chosenSku, product);
    const previewImg = chosenSku?.images?.[0] ? chosenSku?.images?.[0]?.full.url : product?.images?.[0]?.full?.url;
    if(!product) return null;
    return (
        <div className='info'>
            <img className='img' src={previewImg} />
            <div className='info-wrap'>
                <div className='price-wrap'>
                    <div className='preview-price'>
                        <div className='price'>{price.priceTag}</div>
                        <div className='original-price'>{price.originalPriceTag}</div>
                    </div>
                    <div className='main-price'><span className='small'>约</span>{price.priceTagCN}</div>
                </div>
                <div>Name: {product.name} | {product.nameCN}</div>
                <div>ID: {product.id}</div>
                <div>Brand: {product.brand}</div>
                <div>Category: {product.category}</div>
                <div>Inventory: {product.inventoryStatus}</div>
            </div>
        </div>
    )
}

function getPrice(chosenSku, product) {
    if (!chosenSku) {
        return {
            priceTag: product?.promotions?.priceTag,
            originalPriceTag: product?.promotions?.originalPriceTag,
            priceTagCN: product?.promotions?.priceTagCN
        }
    } else {
        const skus = product?.promotions?.skus || [];
        return skus?.find((item) => (item.id === chosenSku.id) || (item.id === '_all'));
    }
}

interface PickerInterface {
    handlePickerClick: (type: string, item: any) => void,
    product: any,
    availableOption: any,
    chosenParam: any
}

function CartColorPicker(props: PickerInterface) {
    const { product, availableOption, chosenParam } = props;
    const availableColor = availableOption?.colors;
    const colors = product?.colors || [];
    const activeColor = chosenParam?.color;

    if (!colors || !colors.length) return null;
    return (
        <div className='m-picker m-cart-color-picker'>
            <div className='title'>颜色：</div>
            {colors.map((item: any, index: number) => {
                const isActive = activeColor && (item.name === activeColor);
                const isAvailable = !availableColor || availableColor.find((ele: any) => ele === item.name);
                if (isActive) {
                    return (
                        <ActivePickerItem key={item.name} handlePickerClick={() => props.handlePickerClick('color', null)}>
                            <div className='picker-img-wrap'>
                                <img src={item?.image?.full?.url} />
                                {item.name}
                            </div>
                        </ActivePickerItem>
                    )
                } else if (isAvailable) {
                    return (
                        <AvailablePickerItem key={item.name} handlePickerClick={() => props.handlePickerClick('color', item.name)}>
                            <div className='picker-img-wrap'>
                                <img src={item?.image?.full?.url} />
                                {item.name}
                            </div>
                        </AvailablePickerItem>
                    );
                } else {
                    return (
                        <DisablePickerItem key={item.name}>
                            <div className='picker-img-wrap'>
                                <img src={item?.image?.full?.url} />
                                {item.name}
                            </div>
                        </DisablePickerItem>
                    );
                }
            })}
        </div>
    )
}

function CartWidthPicker(props: PickerInterface) {
    const { product, availableOption, chosenParam } = props;
    const availableWidth = availableOption?.widths;
    const width = product?.attributes?.attributes?.width?.choices || [];
    const activeWidth = chosenParam?.width;

    if (!width || !width.length) return null;
    return (
        <div className='m-picker m-cart-width-picker'>
            <div className='title'>宽度：</div>
            {width.map((item: any, index: number) => {
                const isActive = activeWidth && (item === activeWidth);
                const isAvailable = !availableWidth || availableWidth.find((ele: any) => ele === item);
                if (isActive) {
                    return (
                        <ActivePickerItem key={item} handlePickerClick={() => props.handlePickerClick('width', null)}>
                            {item}
                        </ActivePickerItem>
                    )
                } else if (isAvailable) {
                    return (
                        <AvailablePickerItem key={item} handlePickerClick={() => props.handlePickerClick('width', item)}>
                            {item}
                        </AvailablePickerItem>
                    );
                } else {
                    return (
                        <DisablePickerItem key={item}>
                            {item}
                        </DisablePickerItem>
                    );
                }
            })}
        </div>
    )
}

function CartSizePicker(props: PickerInterface) {
    const { product, availableOption, chosenParam } = props;
    const availableSize = availableOption?.sizes;
    const sizes = product?.sizes || [];
    const activeSize = chosenParam?.size;
    const activeSizeTips = sizes.find((item: any) => item.name === activeSize)?.displayName;

    if (!sizes || !sizes.length) return null;
    return (
        <div className='m-picker m-cart-size-picker'>
            <div className='title'>
                <div>尺码：<span className='size-tips'>{activeSizeTips}</span></div>
            </div>
            {sizes.map((item: any, index: number) => {
                const isActive = activeSize && (item.name === activeSize);
                const isAvailable = !availableSize || availableSize.find((ele: any) => ele === item.name);
                if (isActive) {
                    return (
                        <ActivePickerItem key={item.name} handlePickerClick={() => props.handlePickerClick('size', null)}>
                            {item.label || item.name}
                        </ActivePickerItem>
                    )
                } else if (isAvailable) {
                    return (
                        <AvailablePickerItem key={item.name} handlePickerClick={() => props.handlePickerClick('size', item.name)}>
                            {item.label || item.name}
                        </AvailablePickerItem>
                    );
                } else {
                    return (
                        <DisablePickerItem key={item.name}>
                            {item.label || item.name}
                        </DisablePickerItem>
                    );
                }
            })}
        </div>
    )
}

interface PickerItemInterface {
    status?: 'active' | 'available' | 'disable',
    handlePickerClick?: () => void,
    children: React.ReactNode
}
function PickerItem(props: PickerItemInterface) {
    function handleClick(event: React.MouseEvent) {
        event.stopPropagation();
        if (props.status && props.status !== 'disable') {
            props.handlePickerClick && props.handlePickerClick();
        }
    }
    return (
        <div
            className={`picker-item ${props.status}`}
            onClick={handleClick}
        >
            {props.children}
        </div>
    )
}

PickerItem.defaultProps = {
    active: true,
    children: ''
}

function AvailablePickerItem(props: PickerItemInterface) {
    return PickerItem({
        ...props,
        status: 'available'
    })
}

function ActivePickerItem(props: PickerItemInterface) {
    return PickerItem({
        ...props,
        status: 'active'
    })
}

function DisablePickerItem(props: PickerItemInterface) {
    return PickerItem({
        ...props,
        status: 'disable'
    })
}

interface choseSkuPatameter {
    color?: string,
    size?: string,
    width?: string
}

function choseSku(choseSkuPatameter: choseSkuPatameter, product: any, chosenParam: any) {
    const skus = product.availableSkus;
    let param = {
        ...chosenParam,
        ...choseSkuPatameter
    };

    //更新不能选择项
    let availableColors: Array<any> | null = null, availableWidths: Array<string> | null = null, availableSizes: Array<any> | null = null;
    if (param.color) {
        skus?.forEach((item: any) => {
            let skuColor = item?.color?.name,
                skuWidth = item?.attributes?.attributes?.width?.choices?.[0],
                skuSize = item?.size?.name;
            if (skuColor === param.color) {
                availableWidths = (availableWidths || []).concat(skuWidth);
                availableSizes = (availableSizes || []).concat(skuSize);
            }
        })
        availableWidths = Array.from(new Set(availableWidths));
        availableSizes = Array.from(new Set(availableSizes));
    }
    if (param.size && (!availableSizes || availableSizes.indexOf(param.size) > -1)) {
        let tempWidth: Array<string> = [];
        skus?.forEach((item: any) => {
            let skuColor = item?.color?.name,
                skuWidth = item?.attributes?.attributes?.width?.choices?.[0],
                skuSize = item?.size?.name;
            if (skuSize === param.size) {
                if (!availableWidths || availableWidths?.find(w => w === skuWidth)) {
                    tempWidth.push(skuWidth);
                }
                availableColors = (availableColors || []).concat(skuColor);
            }
        })
        availableWidths = Array.from(new Set(tempWidth));
        availableColors = Array.from(new Set(availableColors));
    } else {
        param.size = undefined;
    }
    if (param.width && (!availableWidths || availableWidths.indexOf(param.width) > -1)) {
        let tempColor: Array<any> = [];
        let tempSize: Array<any> = [];
        skus?.forEach((item: any) => {
            let skuColor = item?.color?.name,
                skuWidth = item?.attributes?.attributes?.width?.choices?.[0],
                skuSize = item?.size?.name;
            if (skuWidth === param.width) {
                if (!availableColors || availableColors?.find(c => c === skuColor)) {
                    tempColor.push(skuColor);
                }
                if (!availableSizes || availableSizes?.find(s => s === skuSize)) {
                    tempSize.push(skuSize);
                }
            }
        })
        availableColors = Array.from(new Set(tempColor));
        availableSizes = Array.from(new Set(tempSize));
    } else {
        param.width = undefined;
    }
    const allColors = product?.colors?.map((item: any) => item?.name);
    const allWidths = product?.attributes?.attributes?.width?.choices;
    const allSizes = product?.sizes?.map((item: any) => item?.name);
    const availableOption = {
        colors: availableColors || allColors,
        widths: availableWidths || allWidths,
        sizes: availableSizes || allSizes
    }

    //选出sku
    let { color = null, size = null, width = null } = param;
    let sku;
    const hasOption = product?.colors?.length ||
        product?.sizes?.length ||
        product?.attributes?.attributes?.width?.choices?.length;
    if (color || size || width) {
        sku = skus?.find((item: any) => {
            return (!color || color === item?.color?.name)
                && (!size || size === item?.size?.name)
                && (!width || width === item?.attributes?.attributes?.width?.choices?.[0])
        });
    } else if (!hasOption) {
        //无规格选择项
        sku = skus?.[0];
    } else sku = null;

    return {
        chosenParam: {
            ...chosenParam,
            ...param
        },
        chosenSku: sku,
        availableOption
    }
}

function isChosenFinished(product, chosenParam) {
    const chosen = {
        color: chosenParam?.color ?
            chosenParam.color : product?.colors?.length ?
                null : undefined,
        width: chosenParam?.width ?
            chosenParam.width : product?.attributes?.attributes?.width ?
                null : undefined,
        size: chosenParam?.size ?
            chosenParam.size : product?.sizes?.length ?
                null : undefined
    }
    const chosenFinished = (chosen.color !== null) && (chosen.width !== null) && (chosen.size !== null);
    return chosenFinished;
}

export default ProductSkuModal;